export default __webpack_public_path__ + "static/media/i_error404.16857bd7.svg";